import type { ComponentType } from "react";

export interface UpdateEntry {
	slug: string;
	frontmatter: {
		title: string;
		date: string;
	};
	Component: ComponentType;
}

const modules = import.meta.glob<{
	default: ComponentType;
	frontmatter: { title: string; date: string };
}>("/src/content/updates/*.mdx", { eager: true });

export const updates: UpdateEntry[] = Object.entries(modules)
	.map(([path, mod]) => ({
		slug: path.replace("/src/content/updates/", "").replace(".mdx", ""),
		frontmatter: mod.frontmatter,
		Component: mod.default,
	}))
	.sort((a, b) => b.frontmatter.date.localeCompare(a.frontmatter.date));
